import React, { FC, ReactNode, useEffect, useRef } from 'react';

export type ScrollingViewProps = {
  shouldScroll: boolean;
  shouldUpdate?: boolean;
  children: ReactNode;
};

export const ScrollingView: FC<ScrollingViewProps> = ({
  shouldScroll,
  shouldUpdate = false,
  children,
  ...rest
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const height = containerRef?.current?.clientHeight ?? 0;

  useEffect(() => {
    if (containerRef?.current) {
      containerRef.current.scrollIntoView({
        behavior: 'auto',
        block: 'start',
        inline: 'center',
      });
    }
  }, [height, shouldUpdate]);

  if (shouldScroll) {
    return (
      <div data-testid="scrolling-container" {...rest} ref={containerRef}>
        {children}
      </div>
    );
  }

  return (
    <div data-testid="container" {...rest}>
      {children}
    </div>
  );
};
